import _classCallCheck from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _assertThisInitialized from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import $ from 'dom7';
import { window } from 'ssr-window';
import Utils from '../../utils/utils';
import Modal from '../modal/modal-class';

var Toast =
/*#__PURE__*/
function (_Modal) {
  _inherits(Toast, _Modal);

  function Toast(app, params) {
    var _this;

    _classCallCheck(this, Toast);

    var extendedParams = Utils.extend({
      on: {}
    }, app.params.toast, params); // Extends with open/close Modal methods;

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Toast).call(this, app, extendedParams));

    var toast = _assertThisInitialized(_assertThisInitialized(_this));

    toast.app = app;
    toast.params = extendedParams;
    var _toast$params = toast.params,
        closeButton = _toast$params.closeButton,
        closeTimeout = _toast$params.closeTimeout;
    var $el;

    if (!toast.params.el) {
      // Find Element
      var toastHtml = toast.render();
      $el = $(toastHtml);
    } else {
      $el = $(toast.params.el);
    }

    if ($el && $el.length > 0 && $el[0].f7Modal) {
      return _possibleConstructorReturn(_this, $el[0].f7Modal);
    }

    if ($el.length === 0) {
      return _possibleConstructorReturn(_this, toast.destroy());
    }

    Utils.extend(toast, {
      $el: $el,
      el: $el[0],
      type: 'toast'
    });
    $el[0].f7Modal = toast;

    if (closeButton) {
      $el.find('.toast-button').on('click', function () {
        toast.emit('local::closeButtonClick toastCloseButtonClick', toast);
        toast.close();
      });
      toast.on('beforeDestroy', function () {
        $el.find('.toast-button').off('click');
      });
    }

    var timeoutId;
    toast.on('open', function () {
      $('.toast.modal-in').each(function (index, openedEl) {
        var toastInstance = app.toast.get(openedEl);

        if (openedEl !== toast.el && toastInstance) {
          toastInstance.close();
        }
      });

      if (closeTimeout) {
        timeoutId = Utils.nextTick(function () {
          toast.close();
        }, closeTimeout);
      }
    });
    toast.on('close', function () {
      window.clearTimeout(timeoutId);
    });

    if (toast.params.destroyOnClose) {
      toast.once('closed', function () {
        setTimeout(function () {
          toast.destroy();
        }, 0);
      });
    }

    return _possibleConstructorReturn(_this, toast);
  }

  _createClass(Toast, [{
    key: "render",
    value: function render() {
      var toast = this;
      if (toast.params.render) return toast.params.render.call(toast, toast);
      var _toast$params2 = toast.params,
          position = _toast$params2.position,
          cssClass = _toast$params2.cssClass,
          icon = _toast$params2.icon,
          text = _toast$params2.text,
          closeButton = _toast$params2.closeButton,
          closeButtonColor = _toast$params2.closeButtonColor,
          closeButtonText = _toast$params2.closeButtonText;
      return "\n      <div class=\"toast toast-".concat(position, " ").concat(cssClass || '', " ").concat(icon ? 'toast-with-icon' : '', "\">\n        <div class=\"toast-content\">\n          ").concat(icon ? "<div class=\"toast-icon\">".concat(icon, "</div>") : '', "\n          <div class=\"toast-text\">").concat(text, "</div>\n          ").concat(closeButton && !icon ? "\n          <a class=\"toast-button button ".concat(closeButtonColor ? "color-".concat(closeButtonColor) : '', "\">").concat(closeButtonText, "</a>\n          ").trim() : '', "\n        </div>\n      </div>\n    ").trim();
    }
  }]);

  return Toast;
}(Modal);

export default Toast;